<script setup lang="ts">
import { ref } from 'vue';
import { DrawerContent, DrawerPortal } from 'vaul-vue';
import type { DialogContentEmits, DialogContentProps } from 'radix-vue';
import { useForwardPropsEmits } from 'radix-vue';
import type { HtmlHTMLAttributes } from 'vue';
import DrawerOverlay from './DrawerOverlay.vue';
import { cn } from '@laam/lib/utils';

const props = defineProps<
	DialogContentProps & {
		class?: HtmlHTMLAttributes['class'];
		slotClass?: HtmlHTMLAttributes['class'];
		height?: string;
		maxHeight?: number;
	}
>();

const emits = defineEmits<DialogContentEmits>();
const forwarded = useForwardPropsEmits(props, emits);
const drawerHeight = ref(props.height);

let startY = 0;
let currentHeight = 50;

const handleTouchStart = (event: TouchEvent) => {
	startY = event.touches[0]!.clientY;
};
const handleTouchMove = (event: TouchEvent) => {
	const touchY = event.touches[0]!.clientY;
	const deltaY = startY - touchY;
	const newHeight = currentHeight + (deltaY / window.innerHeight) * 100;

	if (newHeight >= currentHeight && newHeight <= props.maxHeight!) {
		drawerHeight.value = `${newHeight}vh`;
	}
};

const handleTouchEnd = () => {
	currentHeight = parseFloat(drawerHeight.value!);
};
</script>

<template>
	<DrawerPortal>
		<DrawerOverlay class="drawer_overlay" />
		<DrawerContent
			v-bind="forwarded"
			:class="
				cn(
					'drawer-content fixed inset-x-none bottom-0 z-50 flex flex-col rounded-t-[10px] border border-gray-200 bg-white max-h-[85vh]',
					props.class,
				)
			"
			:style="{ height: drawerHeight }"
			@touchstart="handleTouchStart"
			@touchmove="handleTouchMove"
			@touchend="handleTouchEnd"
		>
			<div class="mx-auto mt-3xl h-md w-[100px] rounded-full bg-gray-100" />
			<div :class="cn('overflow-auto p-3xl', props.slotClass)">
				<slot />
			</div>
		</DrawerContent>
	</DrawerPortal>
</template>
